import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Deposito } from './depositos.model';

// LOAD
export const entityDepositosLoadRequest = createAction(
  '[ENTITYDEPOSITOS] Load Request'
);

export const entityDepositosLoadFailure = createAction(
  '[ENTITYDEPOSITOS] Load Failure',
  props<{ error: Error }>()
);

export const entityDepositosLoadSuccess = createAction(
  '[ENTITYDEPOSITOS] Load Success',
  props<{ items: Deposito[] }>()
);

// ADD
export const entityDepositosAddRequest = createAction(
  '[ENTITYDEPOSITOS] Add Request',
  props<{ item: Deposito[] }>()
);

export const entityDepositosAddFailure = createAction(
  '[ENTITYDEPOSITOS] Add Failure',
  props<{ error: Error }>()
);

export const entityDepositosAddSuccess = createAction(
  '[ENTITYDEPOSITOS] Add Success',
  props<{ item: Deposito[] }>()
);

// DELETE

export const entityDepositosDeleteSuccess = createAction(
  '[ENTITYDEPOSITOS] Delete Success',
  props<{ item: Deposito }>()
);

export const entityDepositosDeleteRequest = createAction(
  '[ENTITYDEPOSITOS] Delete Request',
  props<{ item: Deposito }>()
);

export const entityDepositosDeleteFailure = createAction(
  '[ENTITYDEPOSITOS] Delete Failure',
  props<{ error: Error }>()
);
